export default "/images/branding-a.webp?900c6490e0ca67ade4b23095c7695e74";